import type { Metadata, MetadataHandler } from 'hooks';

import { pushGTMEvent } from './gtm';
import { pushPlausibleEvent } from './plausible';

export type EventProps = { [key: string]: any };

export enum AnalyticsEvent {
    VIDEO_INTERACTION = 'video_interaction',
    MENU_CLICK = 'menu_click',
    MENU_CONTACT_CLICK = 'menu_contact_click',
    LOGO_CLICK = 'logo_click',
    BURGER_MENU_BUTTON_CLICK = 'burger_menu_button_click',
    LOGO_STRIP_CLICK = 'logo_strip_click',
    CAROUSEL_NUMBER_CLICK = 'carousel_number_click',
    CAROUSEL_TITLE_CLICK = 'carousel_title_click',
    CAROUSEL_CLICK = 'carousel_click',
    CAROUSEL_TEXT_CLICK = 'carousel_text_click',
    CAROUSEL_BW_ARROW_CLICK = 'carousel_bw_arrow_click',
    CAROUSEL_FW_ARROW_CLICK = 'carousel_fw_arrow_click',
    BURGER_MENU_CLICK = 'burger_menu_click',
    BURGER_MENU_SOCIAL_CLICK = 'burger_menu_social_click',
    BURGER_MENU_CLOSE_BUTTON_CLICK = 'burger_menu_close_button_click',
    BURGER_MENU_CONTACT_CLICK = 'burger_menu_contact_click',
    REFERENCES_CATEGORY_CLICK = 'references_category_click',
    PAGE_VIEW_REFERENCES = 'page_view_references',
    VIDEO_SMALL_1_PLAY_BUTTON_CLICK = 'video_small_1_play_button_click',
    VIDEO_SMALL_2_PLAY_BUTTON_CLICK = 'video_small_2_play_button_click',
    VIDEO_SMALL_3_PLAY_BUTTON_CLICK = 'video_small_3_play_button_click',
    VIDEO_BIG_PLAY_BUTTON_CLICK = 'video_big_play_button_click',
    CAROUSEL_PICTURE_1_CLICK = 'carousel_picture_1_click',
    CAROUSEL_PICTURE_2_CLICK = 'carousel_picture_2_click',
    CAROUSEL_PICTURE_3_CLICK = 'carousel_picture_3_click',
    CAROUSEL_PICTURE_4_CLICK = 'carousel_picture_4_click',
    CONTACT_TOP_CLICK = 'contact_top_click',
    CONTACT_BOTTOM_CLICK = 'contact_bottom_click',
    FOOTER_ACKEE_CLICK = 'footer_ackee_click',
    FOOTER_SERVICES_CLICK = 'footer_services_click',
    FOOTER_AWARDS_CLICK = 'footer_awards_click',
    FOOTER_SOCIAL_CLICK = 'footer_social_click',
    CONTACT_FORM_SUBMISSION_SUCCESS = 'contact_form_submission_success',
    CAREER_FORM_SUBMISSION_SUCCESS = 'career_form_submission_success',
    FORM_SUBMISSION_SUCCESS = 'form_submission_success',
    FORM_SUBMISSION_ERROR = 'form_submission_error',
    FORM_SUBMISSION_FAIL = 'form_submission_fail',
    FORM_FIELD_ERROR = 'form_field_error',
    CONTACT_CLICK = 'contact_click',
    BLOG_DEVOPS_CONTACT_CLICK = 'blog_devops_contact_click',
    BLOG_DEVOPS_BANNER_CLICK = 'blog_devops_banner_click',
    BLOG_DEVOPS_REFERENCE_CLICK = 'blog_devops_reference_click',
    WEB3_TEXT_LINK_CLICK = 'web3_text_link_click',
    PAGE_NOT_FOUND = 'page_not_found',
    PAGE_VIEW_COOKIE_CONSENT = 'page_view_cookie_consent',
    COOKIE_BANNER_CLOSED = 'cookie_banner_closed',
    COOKIE_BANNER_VISIBLE = 'cookie_banner_visible',
    COOKIE_SETTINGS_SAVED = 'cookie_settings_saved',
    VIDEO_VISIBLE = 'video_visible',
    VIDEO_PLAY = 'video_play',
    VIDEO_PAUSE = 'video_pause',
    VIDEO_SEEK = 'video_seek',
    VIDEO_COMPLETE = 'video_complete',
    TRAINEE_BOX_VISIBLE = 'trainee_box_visible',
    DEVELOPMENT_VISIBLE_MOBILE = 'development_visible_mobile',
    DEVELOPMENT_VISIBLE_CAROUSEL_ROOT_MOBILE = 'development_visible_carousel_root_mobile',
    DEVELOPMENT_VISIBLE_WEB = 'development_visible_web',
    DEVELOPMENT_VISIBLE_CAROUSEL_ROOT_WEB = 'development_visible_carousel_root_web',
    DEVELOPMENT_VISIBLE_DESIGN = 'development_visible_design',
    DEVELOPMENT_VISIBLE_CAROUSEL_ROOT_DESIGN = 'development_visible_carousel_root_design',
    DEVELOPMENT_TOP_LINK_CLICK = 'development_top_link_click',
}

export const pushAnalyticsEvent = (eventName: AnalyticsEvent, props: EventProps) => {
    pushGTMEvent(eventName, props);
    pushPlausibleEvent(eventName, props);
};

export const sendCaseStudyPageView: MetadataHandler = ({ title }: Metadata) => {
    pushAnalyticsEvent(AnalyticsEvent.PAGE_VIEW_REFERENCES, {
        url: window.location.href,
        route: window.location.pathname,
        page_title: title,
    });
};
